// Currency services rest api calling

import { routes } from "../config/api_routes";

export const resellerService = {
    // get currencyList

    getResellerListing: (formData) => {
        return window.axios.post(routes.getResellerApi, formData);
    },

    addReseller: (formData) => {
        return window.axios.post(
            routes.addResellerBusinessProfileApi,
            formData
        );
    },

    getResellerById: (formData) => {
        return window.axios.post(routes.getResellerByIdApi, formData);
    },

    updateReseller: (formData) => {
        return window.axios.post(
            routes.updateResellerBusinessProfileApi,
            formData
        );
    },

    getAllReseller: () => {
        return window.axios.get(routes.getAllResellerApi);
    },

    getResellerBusinessProfile: (formData) => {
        return window.axios.post(
            routes.getResellerBusinessProfileApi,
            formData
        );
    },
};
